"use client";

import { useEffect, useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
export default function WelcomeToTexasMargariasInCarmel() {
  const {
    ref: textBlockRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const heroRef = useRef<HTMLDivElement>(null);
  const [parallaxOffset, setParallaxOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (heroRef.current) {
        const rect = heroRef.current.getBoundingClientRect();
        const scrolled = window.scrollY;
        const offset = scrolled * 0.5;
        setParallaxOffset(offset);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section ref={heroRef} className="relative min-h-screen w-full overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1474184/img/image_h7a73sft.webp)",
      transform: `translateY(${parallaxOffset}px)`,
      transition: "transform 0.1s ease-out"
    }} />

      {}
      <div className="absolute inset-0 bg-dark-background/30" />

      {}
      <div className="relative z-10 flex min-h-screen items-center justify-center px-6 py-16">
        <div ref={textBlockRef} className={`max-w-2xl transition-all duration-500 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          <Card className="bg-background/90 backdrop-blur-md shadow-strong border-2 border-accent/20">
            <CardContent className="space-y-6 text-center">
              <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-foreground leading-tight">
                Welcome to Texas Margaritas in Carmel!
              </h1>
              <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed">
                Experience authentic Mexican comfort food in a warm, family-friendly atmosphere. From sizzling fajitas to signature margaritas, we bring the vibrant flavors of Texas to Indiana.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
                <Link to="/MenuPage" className="inline-flex items-center justify-center rounded-md bg-primary text-foreground-primary px-8 py-3 font-semibold hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-primary-active active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                  View Menu
                </Link>
                <Link to="/ContactPage" className="inline-flex items-center justify-center rounded-md bg-secondary text-foreground-secondary px-8 py-3 font-semibold hover:bg-secondary-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-secondary-active active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                  Contact Us
                </Link>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}